
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-preparation",
      function () {
        return require("private-next-pages/test-preparation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test-preparation"])
      });
    }
  